import React from 'react';

const MapLegend = () => {
  return (
    <div style={{
      position: 'absolute',
      top: '52px',
      left: '10px',
      backgroundColor: 'rgba(255, 255, 255, 0.7)', // Semi-transparent background
      padding: '4px 8px',
      borderRadius: '2px',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
      zIndex: 10,
      width: 'auto', // Auto width instead of fixed
      fontSize: '12px' // Smaller font size
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '2px'
      }}>
        <div style={{
          width: '12px',
          height: '12px',
          backgroundColor: '#2196F3',
          marginRight: '4px',
          border: '1px solid rgba(0, 0, 0, 0.1)'
        }}></div>
        <span>Blue - Search Radius</span>
      </div>

      <div style={{
        display: 'flex',
        alignItems: 'center'
      }}>
        <div style={{
          width: '12px',
          height: '12px',
          backgroundColor: '#4CAF50',
          marginRight: '4px',
          border: '1px solid rgba(0, 0, 0, 0.1)'
        }}></div>
        <span>Green - Zip Code</span>
      </div>
    </div>
  );
};

export default MapLegend;